import React, { useState, useEffect } from 'react';
import { Users, BookOpen, Building, FileText, TrendingUp, Activity, Target } from 'lucide-react';
import { statsApi } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import LlmQuotaConsoleCard from '../../components/admin/LlmQuotaConsoleCard';

export const AdminOverview = () => {
  const [stats, setStats] = useState({});
  const { user } = useAuth();

  useEffect(() => {
    statsApi.getDashboard().then(setStats).catch(console.error);
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-overview">
      <h1 className="text-2xl font-bold">Dashboard Overview</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {user?.role === 'super_admin' && (
          <>
            <div className="stat-card">
              <Building className="w-8 h-8 text-primary mb-2" />
              <div className="text-2xl font-bold">{stats.total_schools || 0}</div>
              <div className="text-sm text-muted-foreground">Total Schools</div>
            </div>
            <div className="stat-card">
              <Users className="w-8 h-8 text-secondary mb-2" />
              <div className="text-2xl font-bold">{stats.total_users || 0}</div>
              <div className="text-sm text-muted-foreground">Total Users</div>
            </div>
          </>
        )}
        <div className="stat-card">
          <BookOpen className="w-8 h-8 text-green-500 mb-2" />
          <div className="text-2xl font-bold">{stats.total_courses || stats.my_courses || 0}</div>
          <div className="text-sm text-muted-foreground">Courses</div>
        </div>
        <div className="stat-card">
          <Target className="w-8 h-8 text-orange-500 mb-2" />
          <div className="text-2xl font-bold">{stats.pending_requests || 0}</div>
          <div className="text-sm text-muted-foreground">Pending Requests</div>
        </div>
      </div>

      {/* AI Quota Console — only for super_admin */}
      {user?.role === 'super_admin' && <LlmQuotaConsoleCard />}
    </div>
  );
};

// Schools Management
